import React, {useEffect, useState} from 'react';
import BadgeCore from './BadgeCore';

export default function ContinueToGiveBadgeSmall({value}) {
  return <BadgeCore value={value} type="show_badge" />;
}
